<router-outlet></router-outlet>

<div class="floating-bank-details-container" (click)="openBankDetailsPopup()" *ngIf="showBankDetailsButton">
  <div class="floating-bank-details-button">
    <div class="bank-icon">
      <mat-icon>account_balance</mat-icon>
    </div>
    <div class="tooltip-text blink-animation">Merchant <br> Bank Details</div>
  </div>
</div>

<div *ngIf="showBankDetailsPopup" class="popup-overlay">
  <div class="popup bank-details-popup">
    <div class="popup-header">
      <h3>
        <mat-icon class="header-icon">account_balance</mat-icon>
        Merchant Bank Details
      </h3>
      <button (click)="closeBankDetailsPopup()" class="close-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="popup-content">
      <div class="bank-details-list">
        <div class="bank-detail-item" *ngFor="let detail of bankDetails">
          <div class="bank-detail-label">{{detail.label}}:</div>
          <div class="bank-detail-value">
            <span>{{detail.value}}</span>
            <button (click)="copyToClipboard(detail.value, detail.label)" class="copy-btn" mat-icon-button matTooltip="Copy {{detail.label}}">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="note-section">
        <mat-icon>info</mat-icon>
        <span class="note-text">You can copy individual bank details by clicking the copy icon.</span>
      </div>

      <div class="popup-actions">
        <button (click)="copyAllBankDetails()" class="copy-all-btn" mat-raised-button>
          <mat-icon>copy_all</mat-icon>
          Copy All Details
        </button>
        <button (click)="closeBankDetailsPopup()" class="close-btn" mat-button>
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="floating-tollfree-container" (click)="callTollFreeNumber()">
  <div class="floating-tollfree-button">
    <div class="phone-icon">
      <mat-icon>call</mat-icon>
    </div>
  </div>
</div>
